export class Secrets {
    public static GOOGLE_MAP_API_KEY : string = 'AIzaSyCcAIUYCWYupUk4BB-YTybK5Ekd-g2kotU';
    public static SESSION_ID : string = 'SESSION_ID';
    public static USER_TYPE : string = 'USER_TYPE';
    public static LANGUAGE : string = 'LANGUAGE';
}
